import { NgModule } from '@angular/core';
import { CardModule } from 'primeng/card';
import { CardComponent } from './card.component';
import { CommonModule } from '@angular/common';
import { TypographyComponentModule } from '../typography/typography.module';

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, CardModule, TypographyComponentModule],
  exports: [CardModule, CardComponent],
})
export class CardComponentModule {}
